module.exports = __webpack_public_path__ + "_assets/img/service.345f1d02.svg";